import { SVGAttributes } from "react";

export default (props: SVGAttributes<any>) => {
  return (
    <>
      <svg width="780" height="236" viewBox="0 0 800 242" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g clipPath="url(#clip0_23835_149660)">
          <mask id="path-2-inside-1_23835_149660" fill="white">
            <path d="M12 31.6844C12 20.813 20.813 12 31.6844 12H149.369V110.817H31.6844C20.813 110.817 12 102.004 12 91.1321V31.6844Z" />
          </mask>
          <path
            d="M12 31.6844C12 20.813 20.813 12 31.6844 12H149.369V110.817H31.6844C20.813 110.817 12 102.004 12 91.1321V31.6844Z"
            fill="var(--dark-0)"
          />
          <rect width="137.369" height="52.3688" transform="translate(12 12)" fill="var(--dark-2)" />
        </g>
        <path
          d="M10.7697 31.6844C10.7697 20.1336 20.1336 10.7697 31.6844 10.7697H149.369V13.2303H31.6844C21.4925 13.2303 13.2303 21.4925 13.2303 31.6844H10.7697ZM149.369 112.047H31.6844C20.1336 112.047 10.7697 102.683 10.7697 91.1321H13.2303C13.2303 101.324 21.4925 109.586 31.6844 109.586H149.369V112.047ZM31.6844 112.047C20.1336 112.047 10.7697 102.683 10.7697 91.1321V31.6844C10.7697 20.1336 20.1336 10.7697 31.6844 10.7697V13.2303C21.4925 13.2303 13.2303 21.4925 13.2303 31.6844V91.1321C13.2303 101.324 21.4925 109.586 31.6844 109.586V112.047ZM149.369 12V110.817V12Z"
          fill="var(--dark-1)"
          mask="url(#path-2-inside-1_23835_149660)"
        />
        <g clipPath="url(#clip1_23835_149660)">
          <path
            d="M149.369 12H274.857C285.729 12 294.542 20.813 294.542 31.6844V91.1322C294.542 102.004 285.729 110.817 274.857 110.817H149.369V12Z"
            fill="var(--dark-0)"
          />
          <rect width="145.173" height="52.3688" transform="translate(149.369 12)" fill="var(--dark-2)" />
        </g>
        <path
          d="M274.857 12.6152C285.389 12.6153 293.927 21.1529 293.927 31.6846V91.1318C293.927 101.663 285.389 110.201 274.857 110.201H149.984V12.6152H274.857Z"
          stroke="var(--dark-1)"
          strokeWidth="1.23028"
        />
        <g clipPath="url(#clip2_23835_149660)">
          <mask id="path-6-inside-2_23835_149660" fill="white">
            <path d="M12 150.185C12 139.314 20.813 130.501 31.6844 130.501H149.369V229.318H31.6844C20.813 229.318 12 220.505 12 209.633V150.185Z" />
          </mask>
          <path
            d="M12 150.185C12 139.314 20.813 130.501 31.6844 130.501H149.369V229.318H31.6844C20.813 229.318 12 220.505 12 209.633V150.185Z"
            fill="var(--dark-0)"
          />
          <rect width="137.369" height="52.3688" transform="translate(12 130.501)" fill="var(--dark-2)" />
        </g>
        <path
          d="M10.7697 150.185C10.7697 138.635 20.1336 129.271 31.6844 129.271H149.369V131.731H31.6844C21.4925 131.731 13.2303 139.993 13.2303 150.185H10.7697ZM149.369 230.548H31.6844C20.1336 230.548 10.7697 221.184 10.7697 209.633H13.2303C13.2303 219.825 21.4925 228.087 31.6844 228.087H149.369V230.548ZM31.6844 230.548C20.1336 230.548 10.7697 221.184 10.7697 209.633V150.185C10.7697 138.635 20.1336 129.271 31.6844 129.271V131.731C21.4925 131.731 13.2303 139.993 13.2303 150.185V209.633C13.2303 219.825 21.4925 228.087 31.6844 228.087V230.548ZM149.369 130.501V229.318V130.501Z"
          fill="var(--dark-1)"
          mask="url(#path-6-inside-2_23835_149660)"
        />
        <g clipPath="url(#clip3_23835_149660)">
          <path
            d="M149.369 130.501H274.857C285.729 130.501 294.542 139.314 294.542 150.185V209.633C294.542 220.505 285.729 229.318 274.857 229.318H149.369V130.501Z"
            fill="var(--dark-0)"
          />
          <rect width="145.173" height="52.3688" transform="translate(149.369 130.501)" fill="var(--dark-2)" />
        </g>
        <path
          d="M274.857 131.116C285.389 131.116 293.927 139.654 293.927 150.186V209.633C293.927 220.164 285.389 228.702 274.857 228.702H149.984V131.116H274.857Z"
          stroke="var(--dark-1)"
          strokeWidth="1.23028"
        />
        <g clipPath="url(#clip4_23835_149660)">
          <mask id="path-10-inside-3_23835_149660" fill="white">
            <path d="M360.09 90.4334C360.09 79.562 368.903 70.749 379.774 70.749H497.459V170.569H379.774C368.903 170.569 360.09 161.756 360.09 150.885V90.4334Z" />
          </mask>
          <path
            d="M360.09 90.4334C360.09 79.562 368.903 70.749 379.774 70.749H497.459V170.569H379.774C368.903 170.569 360.09 161.756 360.09 150.885V90.4334Z"
            fill="var(--dark-0)"
          />
          <rect width="137.369" height="52.3688" transform="translate(360.09 70.749)" fill="var(--blue-05)" />
        </g>
        <path
          d="M358.86 90.4334C358.86 78.8826 368.223 69.5187 379.774 69.5187H497.459V71.9793H379.774C369.582 71.9793 361.32 80.2415 361.32 90.4334H358.86ZM497.459 171.799H379.774C368.223 171.799 358.86 162.435 358.86 150.885H361.32C361.32 161.077 369.582 169.339 379.774 169.339H497.459V171.799ZM379.774 171.799C368.223 171.799 358.86 162.435 358.86 150.885V90.4334C358.86 78.8826 368.223 69.5187 379.774 69.5187V71.9793C369.582 71.9793 361.32 80.2415 361.32 90.4334V150.885C361.32 161.077 369.582 169.339 379.774 169.339V171.799ZM497.459 70.749V170.569V70.749Z"
          fill="var(--dark-2)"
          mask="url(#path-10-inside-3_23835_149660)"
        />
        <rect x="498.074" y="71.3661" width="143.942" height="98.5863" stroke="var(--blue-1)" strokeWidth="1.23028" />
        <g clipPath="url(#clip5_23835_149660)">
          <rect x="497.459" y="70.751" width="145.173" height="99.8166" fill="var(--dark-0)" />
          <rect width="145.173" height="52.3688" transform="translate(497.459 70.751)" fill="var(--blue-05)" />
        </g>
        <rect x="498.074" y="71.3661" width="143.942" height="98.5863" stroke="var(--dark-2)" strokeWidth="1.23028" />
        <g clipPath="url(#clip6_23835_149660)">
          <mask id="path-15-inside-4_23835_149660" fill="white">
            <path d="M642.631 70.751H768.315C779.187 70.751 788 79.564 788 90.4354V150.883C788 161.755 779.187 170.568 768.315 170.568H642.631V70.751Z" />
          </mask>
          <path
            d="M642.631 70.751H768.315C779.187 70.751 788 79.564 788 90.4354V150.883C788 161.755 779.187 170.568 768.315 170.568H642.631V70.751Z"
            fill="var(--dark-0)"
          />
          <rect width="145.369" height="52.3688" transform="translate(642.631 70.751)" fill="var(--blue-05)" />
        </g>
        <path
          d="M642.631 69.5207H768.315C779.866 69.5207 789.23 78.8845 789.23 90.4354H786.769C786.769 80.2435 778.507 71.9813 768.315 71.9813H642.631V69.5207ZM789.23 150.883C789.23 162.434 779.866 171.798 768.315 171.798H642.631V169.337H768.315C778.507 169.337 786.769 161.075 786.769 150.883H789.23ZM642.631 170.568V70.751V170.568ZM768.315 69.5207C779.866 69.5207 789.23 78.8845 789.23 90.4354V150.883C789.23 162.434 779.866 171.798 768.315 171.798V169.337C778.507 169.337 786.769 161.075 786.769 150.883V90.4354C786.769 80.2435 778.507 71.9813 768.315 71.9813V69.5207Z"
          fill="var(--dark-2)"
          mask="url(#path-15-inside-4_23835_149660)"
        />
        <circle
          cx="4"
          cy="4"
          r="3.5"
          transform="matrix(1 0 0 -1 366 103.5)"
          fill="var( --dark-4)"
          stroke="var( --dark-4)"
        />
        <circle
          cx="4"
          cy="4"
          r="3.5"
          transform="matrix(1 0 0 -1 280 55)"
          fill="var( --dark-4)"
          stroke="var( --dark-4)"
        />
        <path
          d="M284 51H300C307.732 51 314 57.268 314 65V90C314 95.5228 318.477 100 324 100H371"
          stroke="var( --dark-4)"
          strokeWidth="2"
        />
        <circle cx="370" cy="143" r="3.5" fill="var( --dark-4)" stroke="var( --dark-4)" />
        <circle cx="284" cy="191.5" r="3.5" fill="var( --dark-4)" stroke="var( --dark-4)" />
        <path
          d="M284 192H300C307.732 192 314 185.732 314 178V153C314 147.477 318.477 143 324 143H371"
          stroke="var( --dark-4)"
          strokeWidth="2"
        />
        <defs>
          <clipPath id="clip0_23835_149660">
            <path
              d="M12 31.6844C12 20.813 20.813 12 31.6844 12H149.369V110.817H31.6844C20.813 110.817 12 102.004 12 91.1321V31.6844Z"
              fill="white"
            />
          </clipPath>
          <clipPath id="clip1_23835_149660">
            <path
              d="M149.369 12H274.857C285.729 12 294.542 20.813 294.542 31.6844V91.1322C294.542 102.004 285.729 110.817 274.857 110.817H149.369V12Z"
              fill="white"
            />
          </clipPath>
          <clipPath id="clip2_23835_149660">
            <path
              d="M12 150.185C12 139.314 20.813 130.501 31.6844 130.501H149.369V229.318H31.6844C20.813 229.318 12 220.505 12 209.633V150.185Z"
              fill="white"
            />
          </clipPath>
          <clipPath id="clip3_23835_149660">
            <path
              d="M149.369 130.501H274.857C285.729 130.501 294.542 139.314 294.542 150.185V209.633C294.542 220.505 285.729 229.318 274.857 229.318H149.369V130.501Z"
              fill="white"
            />
          </clipPath>
          <clipPath id="clip4_23835_149660">
            <path
              d="M360.09 90.4334C360.09 79.562 368.903 70.749 379.774 70.749H497.459V170.569H379.774C368.903 170.569 360.09 161.756 360.09 150.885V90.4334Z"
              fill="white"
            />
          </clipPath>
          <clipPath id="clip5_23835_149660">
            <rect x="497.459" y="70.751" width="145.173" height="99.8166" fill="white" />
          </clipPath>
          <clipPath id="clip6_23835_149660">
            <path
              d="M642.631 70.751H768.315C779.187 70.751 788 79.564 788 90.4354V150.883C788 161.755 779.187 170.568 768.315 170.568H642.631V70.751Z"
              fill="white"
            />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
